'use client';

import { Dialog } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { InfoDialogProps } from './types/InfoDialogProps';

export default function InfoDialog({ dialogContent, setDialogContent }: InfoDialogProps) {
  return (
    <Dialog
      open={dialogContent !== null}
      className="relative z-40"
      onClose={() => {
        setDialogContent(null);
      }}
    >
      {/* Overlay */}
      <div className="fixed inset-0 bg-neutral-100/20" />
      <Dialog.Panel className="fixed left-1/2 top-1/2 h-fit max-h-[90vh] w-[95vw] -translate-x-1/2 -translate-y-1/2 transform overflow-y-auto rounded-xl bg-white p-6 px-4 py-10 shadow-lg sm:px-10 lg:w-full lg:max-w-5xl">
        <button
          onClick={() => setDialogContent(null)}
          className="absolute right-5 top-5 rounded-xl p-1 duration-200 ease-in hover:bg-neutral-10"
        >
          <XMarkIcon className="h-6 w-6" />
        </button>
        <div className="mx-auto max-w-5xl">{dialogContent}</div>
      </Dialog.Panel>
    </Dialog>
  );
}
